import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { MhyChakraProps } from '../types';

const FullWidthBlock: FC<MhyChakraProps> = ({ children, ...rest }) => (
  <Box
    width="100vw"
    position="relative"
    left="50%"
    right="50%"
    marginLeft="-50vw"
    marginRight="-50vw"
    overflowX="hidden"
    {...rest}
  >
    {children}
  </Box>
);

export default FullWidthBlock;
